export const UtilsBrowser = {
  isInternetExplorer: (): boolean => {
    const ua = window.navigator.userAgent;

    // MSIE: IE 10 or older
    // Trident: IE 11
    if (ua.indexOf("MSIE ") > 0 || ua.indexOf("Trident/") > 0) {
      return true;
    }

    return false;
  },
};
